<template>
  <div  v-if="!isProcessing" class="container-fluid concessionaire-form p-3">
    <div class="row mb-3">
      <div class="col-md-2 col-form-label">
        <label class="form-label">Code</label>
      </div>
      <div class="col-md-4">
        <input 
          v-model="loadedConcessionaire.userPK_UM" 
          class="form-control" 
          type="text"
        >
      </div>
      <div class="col-md-2 col-form-label">
        <label class="form-label">Remarks</label>
      </div>
      <div class="col-md-4">
        <textarea 
          v-model="remarks" 
          class="form-control" 
          rows="3"
        ></textarea>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-2 col-form-label">
        <label class="form-label">Last Name</label>
      </div>
      <div class="col-md-4">
        <input 
          v-model="loadedConcessionaire.nameLast_UM" 
          class="form-control" 
          style="text-transform:uppercase"
          type="text"
          @blur="processLastName"
        >
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-2 col-form-label">
        <label class="form-label">First Name</label>
      </div>
      <div class="col-md-4">
        <input 
        ref="fnameRef"
        style="text-transform:uppercase"
          v-model="loadedConcessionaire.nameFirst_UM" 
          class="form-control" 
          type="text"
        >
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-2 col-form-label">
        <label class="form-label">Middle Name</label>
      </div>
      <div class="col-md-4">
        <input 
        style="text-transform:uppercase"
          v-model="loadedConcessionaire.nameMiddle_UM" 
          class="form-control" 
          type="text"
        >
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-2 col-form-label">
        <label class="form-label">Birth Date</label>
      </div>
      <div class="col-md-4">
        <input 
          v-model="loadedConcessionaire.dateBirth_UM" 
          class="form-control" 
          type="date"
        >
      </div>
      <div class="col-md-2 col-form-label">
        <label class="form-label">Gender</label>
      </div>
      <div class="col-md-4">
        <select 
          v-model="loadedConcessionaire.sBMayor_UM" 
          class="form-select"
        >
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-2 col-form-label">
        <label class="form-label">Address</label>
      </div>
      <div class="col-md-10">
        <textarea 
          v-model="loadedConcessionaire.addressBilling_UM" 
          class="form-control" 
          rows="2"
        ></textarea>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-2 col-form-label">
        <label class="form-label">Citizenship</label>
      </div>
      <div class="col-md-4">
        <select 
          v-model="loadedConcessionaire.nameInitials_UM" 
          class="form-select" 
        >
          <option v-for="citizenship in citizenships" :key="citizenship" :value="citizenship">{{citizenship}}</option>
        </select>
      </div>
      <div class="col-md-2 col-form-label">
        <label class="form-label">Civil Status</label>
      </div>
      <div class="col-md-4">
        <select 
          v-model="loadedConcessionaire.nameSpeak_UM" 
          class="form-select"
        >
          <option value="Single">Single</option>
          <option value="Married">Married</option>
          <option value="Widower">Widower</option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-2 col-form-label">
        <label class="form-label">Mobile No</label>
      </div>
      <div class="col-md-4">
        <input 
          v-model="loadedConcessionaire.telNumShipping_UM" 
          class="form-control" 
          type="tel"
        >
      </div>
      <div class="col-md-2 col-form-label">
        <label class="form-label">Birth Place</label>
      </div>
      <div class="col-md-4">
        <input 
          v-model="loadedConcessionaire.cityMunicipality_UM" 
          class="form-control" 
          type="text"
        >
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-2 col-form-label">
        <label class="form-label">TIN Number</label>
      </div>
      <div class="col-md-4">
        <input 
          v-model="loadedConcessionaire.tINVATNumber_UM" 
          class="form-control" 
          type="text"
        >
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 d-flex justify-content-end gap-2">
        <button @click="save" class="btn btn-primary px-4">Save</button>
        <button @click="cancel" class="btn btn-danger px-4">Cancel</button>
      </div>
    </div>
  </div>
 <div v-else class="d-flex justify-content-center align-items-center">
        <SpinnerBlock/>
  </div>
</template>

<script setup>
import { ref,watch } from 'vue'
import toastService from '@/services/toastService'
import umService from '@/services/umService'
import SpinnerBlock from '@/components/animations/SpinnerBlock.vue'
// eslint-disable-next-line
const props = defineProps({
  typedName: String
})

const fnameRef = ref(null);
// eslint-disable-next-line
const emit = defineEmits(['concessionaire-added', 'cancel'])
const isProcessing =ref(false);
const loadedConcessionaire = ref({
  userPK_UM: '',
  nameLast_UM: '',
  nameFirst_UM: '',
  nameMiddle_UM: '',
  dateBirth_UM: null,
  module_UM: 'CNCSSNER',
  sBMayor_UM: 'Male',
  addressBilling_UM: '',
  nameInitials_UM: 'Filipino',
  nameSpeak_UM: 'Single',
  telNumShipping_UM: '',
  cityMunicipality_UM: 'Palompon',
  tINVATNumber_UM: '',
})

const remarks = ref('')
const citizenships = ref(['Filipino', 'American', 'Chinese', 'Japanese', 'Korean'])


function processName(name) {
  if (!name || typeof name !== 'string') {
    loadedConcessionaire.value.lastName_UM = '';
    return;
  }

  const parts = name.split(',').map(part => part.trim());
  
  // If no comma found, use entire string as last name
  if (parts.length >= 1) {
    loadedConcessionaire.value.nameLast_UM = parts[0] || '';
    if(parts.length > 1){
        loadedConcessionaire.value.nameFirst_UM = parts[1] || '';
    }
    setTimeout(()=>{
    fnameRef.value?.focus();
    },150)
    return;
  }

  // Use the part before first comma as last name
  loadedConcessionaire.value.lastName_UM = parts[0] || '';
}
watch(()=>props.typedName,(newValue)=>{
    processName(newValue)
},{immediate: true});

async function save() {
   if(loadedConcessionaire.value.nameFirst_UM?.trim()===''){
    toastService.error('First Name required');
    return;
   }
    isProcessing.value =true;
  const response = await umService.saveConcessionaire(loadedConcessionaire.value);
  if(response.success){
    emit('concessionaire-added',response.data)
    toastService.success('Account added successfuly.')
  }
  else
  {
    toastService.error(response.message);
  }
  isProcessing.value = false;
  //emit('save', loadedConcessionaire.value)
}

function cancel() {
  emit('cancel')
}
</script>

<style scoped>
.concessionaire-form {
  background-color: #f8f9fa;
  border-radius: 0.5rem;
}

.col-form-label {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 1rem;
}

@media (max-width: 768px) {
  .col-form-label {
    justify-content: flex-start;
    padding-right: 0;
    padding-bottom: 0.5rem;
  }
}
</style>